import { asyncThunkWrapper } from "../thunkHandler";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASEURI, headers } from "../../utils/helper";

// Retrieve all member payments
export const handleRetrieveMemberPayments = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || 10,
      page: data?.page || 1,
    };

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/member/payments`,
      },
      thunkAPI,
      {
        toast: false,
      }
    );
  }
);

export const handleGetSubscriptionPlans = createAsyncThunk(
  "subscription/getPlans",
  async (_, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/subscription/plans`,
      },
      thunkAPI,
      {
        toast: false,
      }
    );
  }
);

export const handleCreateSubscriptionCheckout = createAsyncThunk(
  "subscription/createCheckout",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/member/subscription/create-checkout-session`,
        data,
      },
      thunkAPI,
      {
        toast: true,
      }
    );
  }
);

export const handleGetMySubscription = createAsyncThunk(
  "subscription/getMySubscription",
  async (_, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/member/subscription/my-subscription`,
      },
      thunkAPI,
      {
        toast: false,
      }
    );
  }
);

export const handleCancelSubscription = createAsyncThunk(
  "subscription/cancel",
  async (_, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/member/subscription/cancel`,
      },
      thunkAPI,
      {
        toast: true,
      }
    );
  }
);

export const handleRestoreSubscription = createAsyncThunk(
  "subscription/restore",
  async (_, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/member/subscription/restore`,
      },
      thunkAPI,
      {
        toast: true,
      }
    );
  }
);

export const handleUpgradeSubscription = createAsyncThunk(
  "subscription/upgrade",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/member/subscription/upgrade`,
        data,
      },
      thunkAPI,
      {
        toast: true,
      }
    );
  }
);

export const handleDowngradeSubscription = createAsyncThunk(
  "subscription/downgrade",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/member/subscription/upgrade`,
        data,
      },
      thunkAPI,
      {
        toast: true,
      }
    );
  }
);

export const handleCancelPendingDowngrade = createAsyncThunk(
  "subscription/cancelPendingDowngrade",
  async (_, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/member/subscription/cancel-pending-downgrade`,
      },
      thunkAPI,
      {
        toast: true,
      }
    );
  }
);

export const handleCreatePortalSession = createAsyncThunk(
  "subscription/createPortalSession",
  async (_, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/member/subscription/create-portal-session`,
      },
      thunkAPI,
      {
        toast: false,
      }
    );
  }
);